export enum InscriptionPath {
  DOCUMENTS = 'documents',
  EDITION = 'edition-inscription',
  EDITION_GENERAL = 'general',
  CREATION_INSCRIPTION_BY_IDSESSION = 'creation-inscription-by-session',
  CREATION_INSCRIPTION_BY_IDPARTICIPANT = 'creation-inscription-by-participant',
  ID_INSCRIPTION_PARAM = 'idInscription',
  ID_SESSION_PARAM = 'IdSession',
  ID_PARTICIPANT_PARAM = 'idParticipant',
  FINANCEMENT = 'financement',
  EDITION_FACTURE = 'edition-facture',
  VISUALISE_FACTURE = 'visualise-facture',
  ID_FACTURE_PARAM_MAP = 'IdFacture',
  RESUME_INSCRIPTION = 'resume-inscription',
  MODULES = 'modules',
}
